import React, { Component } from 'react';

class ConversationItem extends Component {

  render() {
    return (
      <tbody>

        <tr>
          <td>{this.props.index}</td>
          <td></td>
          <td>
            <p><b>{this.props.owner && this.props.owner.fullname}</b></p>
          </td>
          <td>
            <p>
              Email: <i>{this.props.owner && this.props.owner.email}</i><br/>
              SĐT: <i>{this.props.owner && this.props.owner.phone}</i>
            </p>
          </td>
          <td>{this.props.actionPanel}</td>
        </tr>

      </tbody>
    );
  }

}

export default ConversationItem;



// WEBPACK FOOTER //
// ./components/conversations/ConversationItem.jsx